import * as EVENTS from '../constants/external-events';
import { VISA } from '../constants/partnering-networks';
import collapsedLogger from '../helpers/collapsed-logger';
import getNetworkInstance from '../helpers/get-network-instance';
import logger from '../helpers/logger';
import OrchCustomData from '../helpers/orch-custom-data';
import sendMessageToVisaSrci from '../helpers/send-message-to-visa-srci';
import sortCardList from '../helpers/sort-card-list';

// take all sdks getSrcProfile response as input and returns a list of combined cards
const handleSrcProfiles = () => {
  return new Promise(resolve => {
    const profiles = [];
    let allErrors = true;
    const eventId = EVENTS.ORCH_GET_SRC_PROFILE;
    const responses = OrchCustomData.srcSdks.apiResponseCache.getSrcProfile;
    logger('OrchCustomData.srcSdks.apiResponseCache.getSrcProfile => ', responses);
    for (const key in responses) {
      if (!responses[key].error) {
        allErrors = false;
        if (responses[key].profiles && responses[key].profiles.length > 0) {
          collapsedLogger('Profile responses individual => ', responses[key].profiles);
          const srcProfiles = responses[key].profiles;
          let maskedCards = [];
          if (srcProfiles.length === 1) {
            maskedCards = srcProfiles[0].maskedCards;
          } else {
            for (let i = 0; i < srcProfiles.length; i++) {
              maskedCards = [...maskedCards, ...srcProfiles[i].maskedCards];
            }
          }
          profiles.push({
            [key]: {
              profiles: [{ cardList: maskedCards }],
              srcCorrelationId: responses[key].srcCorrelationId
            }
          });
        }
      }
    }
    const preferredNetwork = OrchCustomData.srcSdks.orchConfig.preferredNetwork || VISA;
    if (allErrors) {
      sendMessageToVisaSrci(eventId, {
        error: responses[preferredNetwork].error
      });
      resolve({ error: responses[preferredNetwork].error });
    } else {
      collapsedLogger('Src Profiles sendToVisaSrci => ', profiles);
      sendMessageToVisaSrci(eventId, { profiles });
      if (profiles.length === 0 && responses[preferredNetwork].error) {
        resolve({ error: responses[preferredNetwork].error });
      } else {
        const maskedCards = sortCardList(profiles);
        if (OrchCustomData.isVsb) {
          const vco = getNetworkInstance(OrchCustomData, VISA);
          vco.trackCardPresentedEvent(maskedCards);
        }
        resolve({ maskedCards });
      }
    }
  });
};

export default handleSrcProfiles;
